/**
 * @fileoverview デバイスドライバーのインストール方法
 */

import { HashLink } from "react-router-hash-link";
import startMenu11J from "./img/win11_start.png";
import systemWindow11J from "./img/win11_online01.png";
import windowsUpdate11J from "./img/win11_online02.png";
import optionWindow11J from "./img/win11_online03.png";
import displayOption11J from "./img/win11_online04.png";
import downloadAndInstallDriver11J from "./img/win11_online05.png";
import startDownload11J from "./img/win11_online06.png";
import finishInstall11J from "./img/win11_online07.png";
import startMenu10J from "./img/win10_start.png";
import settingWindow10J from "./img/win10_online01.png";
import windowsUpdate10J from "./img/win10_online02.png";
import starInstall10J from "./img/win10_online03.png";
import finishInstall10J from "./img/win10_online04.png";
import startMenuRightClickJ from "./img/win11_inst01.png";
import selectUpdateDriverJ from "./img/win11_inst03.png";
import searchDriverJ from "./img/win11_inst04.png";
import startInstallJ from "./img/win11_inst05.png";
import finishInstallJ from "./img/win11_inst06.png";
import checkSerialNoJ from "./img/checkSerialNo.png";
import startMenu11E from "./img/English/win11_start_e.png";
import systemWindow11E from "./img/English/win11_online01_e.png";
import windowsUpdate11E from "./img/English/win11_online02_e.png";
import optionWindow11E from "./img/English/win11_online03_e.png";
import displayOption11E from "./img/English/win11_online05_e.png";
import downloadAndInstallDriver11E from "./img/English/win11_online06_e.png";
import startDownload11E from "./img/English/win11_online07_e.png";
import finishInstall11E from "./img/English/win11_online08_e.png";
import startMenu10E from "./img/English/win10inst_e_01.png";
import settingWindow10E from "./img/English/win10inst_e_02.png";
import windowsUpdate10E from "./img/English/win10inst_e_04.png";
import starInstall10E from "./img/English/win10inst_e_05.png";
import finishInstall10E from "./img/English/win10inst_e_06.png";
import startMenuRightClickE from "./img/English/driverInstall2.png";
import selectUpdateDriverE from "./img/English/driverInstall5.png";
import searchDriverE from "./img/English/driverInstall6.png";
import startInstallE from "./img/English/driverInstall7.png";
import finishInstallE from "./img/English/driverInstall8.png";
import checkSerialNoE from "./img/English/checkSerialNo.png";
import startMenu11K from "./img/Korean/win11_start_k.png";
import systemWindow11K from "./img/Korean/win11_online01_k.png";
import windowsUpdate11K from "./img/Korean/win11_online02_k.png";
import optionWindow11K from "./img/Korean/win11_online03_k.png";
import displayOption11K from "./img/Korean/win11_online04_k.png";
import downloadAndInstallDriver11K from "./img/Korean/win11_online05_k.png";
import startDownload11K from "./img/Korean/win11_online06_k.png";
import finishInstall11K from "./img/Korean/win11_online07_k.png";
import startMenu10K from "./img/Korean/win10inst_k_01.png";
import settingWindow10K from "./img/Korean/win10inst_k_02.png";
import windowsUpdate10K from "./img/Korean/win10inst_k_04.png";
import starInstall10K from "./img/Korean/win10inst_k_05.png";
import finishInstall10K from "./img/Korean/win10inst_k_06.png";
import startMenuRightClickK from "./img/Korean/driverInstall0.png";
import selectUpdateDriverK from "./img/Korean/driverInstall1.png";
import searchDriverK from "./img/Korean/driverInstall2.png";
import startInstallK from "./img/Korean/driverInstall3.png";
import finishInstallK from "./img/Korean/driverInstall4.png";
import connecting from "./img/connecting.png";
import { Step } from "../components/Step";
import { useTranslation } from "react-i18next";

/**
 * テーブル行のプロパティ
 */
interface TableRowProps {
  os: string;
  onLink: string;
  offLink: string;
}

/**
 * リンク付きのテーブル行
 * @param {TableRowProps} props
 * @param {string} props.os OS名
 * @param {string} props.onLink インターネット接続時のリンク
 * @param {string} props.offLink インターネット未接続時のリンク
 * @returns
 */
const LinkTableRow: React.FC<TableRowProps> = ({ os, onLink, offLink }) => {
  const { t } = useTranslation();
  return (
    <tr className="c-table__row">
      <td className="c-table__cell">{os}</td>
      <td className="c-table__cell">
        <HashLink to={onLink}>{t("接続")}</HashLink>
      </td>
      <td className="c-table__cell">
        <HashLink to={offLink}>{t("接続なし")}</HashLink>
      </td>
    </tr>
  );
};

/**
 * デバイスドライバーインストール後の確認へのリンク
 * @returns
 */
const AfterInstallLink: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      →
      <HashLink to="#afterInstall">
        {t("デバイスドライバーインストール後の確認")}
      </HashLink>
    </div>
  );
};

/**
 * デバイスドライバーのインストール方法のコンポーネント
 * @returns デバイスドライバーのインストール方法のJSX Element
 */
export const HowToInstallDeviceDriver: React.FC = () => {
  const { t, i18n } = useTranslation();

  // 画像の設定
  const images = {
    ja: {
      startMenu11: startMenu11J,
      systemWindow11: systemWindow11J,
      windowsUpdate11: windowsUpdate11J,
      optionWindow11: optionWindow11J,
      displayOption11: displayOption11J,
      downloadAndInstallDriver11: downloadAndInstallDriver11J,
      startDownload11: startDownload11J,
      finishInstall11: finishInstall11J,
      startMenu10: startMenu10J,
      settingWindow10: settingWindow10J,
      windowsUpdate10: windowsUpdate10J,
      starInstall10: starInstall10J,
      finishInstall10: finishInstall10J,
      startMenuRightClick: startMenuRightClickJ,
      selectUpdateDriver: selectUpdateDriverJ,
      searchDriver: searchDriverJ,
      startInstall: startInstallJ,
      finishInstall: finishInstallJ,
      checkSerialNo: checkSerialNoJ,
    },
    en: {
      startMenu11: startMenu11E,
      systemWindow11: systemWindow11E,
      windowsUpdate11: windowsUpdate11E,
      optionWindow11: optionWindow11E,
      displayOption11: displayOption11E,
      downloadAndInstallDriver11: downloadAndInstallDriver11E,
      startDownload11: startDownload11E,
      finishInstall11: finishInstall11E,
      startMenu10: startMenu10E,
      settingWindow10: settingWindow10E,
      windowsUpdate10: windowsUpdate10E,
      starInstall10: starInstall10E,
      finishInstall10: finishInstall10E,
      startMenuRightClick: startMenuRightClickE,
      selectUpdateDriver: selectUpdateDriverE,
      searchDriver: searchDriverE,
      startInstall: startInstallE,
      finishInstall: finishInstallE,
      checkSerialNo: checkSerialNoE,
    },
    ko: {
      startMenu11: startMenu11K,
      systemWindow11: systemWindow11K,
      windowsUpdate11: windowsUpdate11K,
      optionWindow11: optionWindow11K,
      displayOption11: displayOption11K,
      downloadAndInstallDriver11: downloadAndInstallDriver11K,
      startDownload11: startDownload11K,
      finishInstall11: finishInstall11K,
      startMenu10: startMenu10K,
      settingWindow10: settingWindow10K,
      windowsUpdate10: windowsUpdate10K,
      starInstall10: starInstall10K,
      finishInstall10: finishInstall10K,
      startMenuRightClick: startMenuRightClickK,
      selectUpdateDriver: selectUpdateDriverK,
      searchDriver: searchDriverK,
      startInstall: startInstallK,
      finishInstall: finishInstallK,
      checkSerialNo: checkSerialNoE,
    },
  };

  //現在の言語に基づいて画像決定
  const currentImages =
    i18n.language === "ja"
      ? images.ja
      : i18n.language === "ko"
      ? images.ko
      : images.en;

  /**
   * Windows 11でインターネットに接続している場合のインストール手順
   */
  const steps_windows11 = [
    {
      step: "1.",
      text: t("スタートボタンをクリックし、[設定]をクリックします。"),
      image: currentImages.startMenu11,
      alt: t("スタートメニュー"),
    },
    {
      step: "2.",
      text: t("[Windows Update]をクリックします。"),
      image: currentImages.systemWindow11,
      alt: t("システム画面"),
    },
    {
      step: "3.",
      text: (
        <>
          {t(
            "Windows Update画面が開き自動的に更新プログラムの確認が始まります。"
          )}
          {t(
            "[更新プログラムのチェック]が表示されたら、[更新プログラムのチェック]をクリックして、再度更新プログラムの確認を行います。"
          )}
          {t(
            "更新プログラムの確認が終了したら、[その他のオプション]の[詳細オプション]をクリックします。"
          )}
        </>
      ),
      image: currentImages.windowsUpdate11,
      alt: t("Windows Update画面"),
    },
    {
      step: "4.",
      text: t(
        "詳細オプション画面で、[追加オプション]の[オプションの更新プログラム]をクリックします。"
      ),
      image: currentImages.optionWindow11,
      alt: t("詳細オプション画面"),
    },
    {
      step: "5.",
      text: t(
        "オプションの更新プログラムを表示画面で、[ドライバー更新プログラム]をクリックします。"
      ),
      image: currentImages.displayOption11,
      alt: t("オプションの更新プログラムを表示画面"),
    },
    {
      step: "6.",
      text: t(
        "[GASTEC CORPORATION - Other hardware - GASTEC GHS-8AT]にチェックをして、[ダウンロードとインストール]をクリックします。"
      ),
      image: currentImages.downloadAndInstallDriver11,
      alt: t("デバイスドライバーの選択"),
    },
    {
      step: "7.",
      text: t("ドライバーのダウンロードとインストールを開始します。"),
      image: currentImages.startDownload11,
      alt: t("ドライバーのダウンロードとインストール"),
    },
    {
      step: "8.",
      text: t("インストール終了後、設定画面を閉じます。"),
      image: currentImages.finishInstall11,
      alt: t("インストール終了"),
    },
  ];

  /**
   * Windows 10でインターネットに接続している場合のインストール手順
   */
  const steps_windows10 = [
    {
      step: "1.",
      text: t("スタートボタンをクリックし、[設定]をクリックします。"),
      image: currentImages.startMenu10,
      alt: t("スタートメニュー"),
    },
    {
      step: "2.",
      text: t("[更新とセキュリティ]をクリックします。"),
      image: currentImages.settingWindow10,
      alt: t("設定画面"),
    },
    {
      step: "3.",
      text: (
        <>
          {t(
            "Windows Update画面が開き自動的に更新プログラムの確認が始まります。"
          )}
          {t(
            "[更新プログラムのチェック]が表示されたら、[更新プログラムのチェック]をクリックして、再度更新プログラムの確認を行います。"
          )}
        </>
      ),
      image: currentImages.windowsUpdate10,
      alt: t("Windows Update画面"),
    },
    {
      step: "4.",
      text: (
        <>
          {t(
            "更新プログラムの確認が終了し[GASTEC CORPORATION - Other hardware - GASTEC GHS-8AT]のダウンロードとインストールを開始します。"
          )}
          {t(
            "[今すぐインストール]ボタンが表示されたら，ボタンをクリックしてインストールを開始します。"
          )}
        </>
      ),
      image: currentImages.starInstall10,
      alt: t("インストール開始"),
    },
    {
      step: "5.",
      text: t("インストール終了後、設定画面を閉じます。"),
      image: currentImages.finishInstall10,
      alt: t("インストール終了"),
    },
  ];

  /**
   * インターネットに接続していない場合のインストール手順
   */
  const steps_offline = [
    {
      step: "1.",
      text: t(
        "スタートボタンを右クリックし、[デバイスマネージャー]をクリックします。"
      ),
      image: currentImages.startMenuRightClick,
      alt: t("スタートメニュー右クリックで表示する画面"),
    },
    {
      step: "2.",
      text: t(
        "[デバイスマネージャー]内で[ほかのデバイス]-[GHS-8AT]を右クリックし，[ドライバーの更新(P)]をクリックします。"
      ),
      image: currentImages.selectUpdateDriver,
      alt: t("ドライバーの更新"),
    },
    {
      step: "3.",
      text: t(
        "[ドライバーの検索方法]の画面で[コンピューターを参照してドライバーソフトウェアを検索(R)ドライバーを手動で検索してインストールします。]を選択します。"
      ),
      image: currentImages.searchDriver,
      alt: t("ドライバーの検索方法画面"),
    },
    {
      step: "5.",
      text: (
        <>
          {t(
            "[コンピューター上のドライバーを参照します。]の画面で[参照]ボタンを選択してデバイスドライバーダウンロード後、解凍されたフォルダ[USBDrivers]を指定します。"
          )}
          {t(
            "この際には必ず[サブフォルダーも検索する]のチェックボックスにチェックを入れてください。"
          )}
          {t("[次へ]ボタンをクリックします。")}
        </>
      ),
      image: currentImages.startInstall,
      alt: t("コンピューター上のドライバーを参照します画面"),
    },
    {
      step: "6.",
      text: (
        <>
          {t(
            "[ドライバーが正常に更新されました。]の画面が表示されてドライバーのインストールが終了します。"
          )}
          {t("[閉じる]を選択します。")}
        </>
      ),
      image: currentImages.finishInstall,
      alt: t("ドライバーが正常に更新されました画面"),
    },
  ];

  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">
          {t("デバイスドライバーのインストール方法")}
        </h2>
        <p className="c-text">
          {t("デバイスドライバーのインストール手順をお知らせします。")}
        </p>

        <h4 className="p-heading-4">{t("はじめに 本体とパソコンの接続")}</h4>
        <p className="c-text">
          {t("専用の付属USB ケーブルを使用しGHS-8AT とパソコンを接続します。")}
          {t(
            "以降の操作はGHS-8ATを接続するパソコンのOSとインターネット接続環境に応じて手順が異なります。"
          )}
          {t("以下から選択してください。")}
        </p>

        <table className="c-table">
          <thead>
            <tr className="c-table__row">
              <th className="c-table__cell c-table__cell--w10">OS</th>
              <th className="c-table__cell" colSpan={2}>
                {t("インターネット")}
              </th>
            </tr>
          </thead>
          <tbody>
            <LinkTableRow os="Windows 11" onLink="#win11_on" offLink="#off" />
            <LinkTableRow os="Windows 10" onLink="#win10_on" offLink="#off" />
          </tbody>
        </table>

        <h3 className="p-heading-3">{t("インターネットに接続している場合")}</h3>
        <p className="c-text">
          {t("Windows Updateからドライバーソフトウェアをインストールします。")}
        </p>

        <h4 className="p-heading-4" id="win11_on">
          Windows 11
        </h4>
        {steps_windows11.map((step, index) => (
          <Step
            step={step.step}
            text={step.text}
            image={step.image}
            alt={step.alt}
          />
        ))}

        <AfterInstallLink />

        <h4 className="p-heading-4" id="win10_on">
          Windows 10
        </h4>
        {steps_windows10.map((step, index) => (
          <Step
            step={step.step}
            text={step.text}
            image={step.image}
            alt={step.alt}
          />
        ))}

        <AfterInstallLink />

        <h3 className="p-heading-3" id="off">
          {t("インターネットに接続していない場合")}
        </h3>
        <p className="c-text">
          {t(
            "インターネットに接続されたパソコンでデバイスドライバーをダウンロードし、その後GHS-8ATを接続したいパソコンにダウンロードしたデバイスドライバーをコピーしてから、ドライバーのインストールを行います。"
          )}
          <br />→
          <a href="/anasys/HowToDownloadDeviceDriver">
            {t("デバイスドライバーのダウンロード方法")}
          </a>
        </p>
        {steps_offline.map((step, index) => (
          <Step
            key={index}
            step={step.step}
            text={step.text}
            image={step.image}
          />
        ))}
        <AfterInstallLink />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2" id="afterInstall">
          {t("デバイスドライバーインストール後の確認")}
        </h2>
        <p className="c-text">
          {t(
            "アナシスを起動して、メニューの[通信]-[本体,センサ,校正情報]をクリックします。"
          )}
          {t(
            "本体，センサ，校正情報ウィンドウの左上に表示される製造番号と，本体上部の製造銘版に記載されている製造番号が一致するか確認してください。"
          )}
        </p>
        <img
          src={currentImages.checkSerialNo}
          alt={t("製造番号確認")}
          className="step-image"
        />
        <p className="c-text">
          {t(
            "液晶表示器には下図のように通信状態になった表示に切り替わります。"
          )}
        </p>
        <img
          src={connecting}
          alt={t("GHS-8ATパソコン接続中表示")}
          className="step-image"
        />
      </section>
    </div>
  );
};
